<template>
  <div>
    <div id="fContents">
      <div id="conList">
        <div class="forumOne" v-for="(item, index) in tableData" :key="index">
          <div class="fCon">
            <router-link tag="div" :to="{path:'/Social/forumDetials', query:{id:item.id,t:encodeURIComponent(item.title)}}"
              class="imgs">
              <img style="width: 100%;height: 100%;" :src="item.picture" />
            </router-link>
            <div class="conList">
              <router-link tag="div" :to="{path:'/Social/forumDetials', query:{id:item.id,t:encodeURIComponent(item.title)}}">{{ item.title }}</router-link>
              <div><span>活动时间：</span><span>{{ item.hstime }}</span>&nbsp;-&nbsp;<span>{{ item.hetime }}</span></div>
              <div><span>报名时间：</span><span>{{ item.bstime }}</span>&nbsp;-&nbsp;<span>{{ item.betime }}</span></div>
              <div><span>主讲人：</span>{{ item.jname }}</div>
              <div><span>简介：</span>{{item.introductionstr}}</div>
              <div><span>活动地点：</span>{{ item.address }}</div>
              <div style="color: #FF2222;"><span>已预约人数：</span><span>{{ item.numbers }}</span></div>
              <div>
                <span v-if="item.wtate === '预约报名'">
                  <router-link tag="el-button" :to="{path:'/Social/forumbm', query:{id:item.id,title:item.title}}"
                    class="btn" type="success">{{item.wtate}}</router-link>
                </span>
                <span v-else-if="item.wtate === '报名未开始'">
                  <el-button size="mini" round>{{item.wtate}}</el-button>
                </span>
                <span v-else-if="item.wtate === '进行中'">
                  <el-button size="mini" round type="warning">{{item.wtate}}</el-button>
                </span>
                <span v-else>
                  <el-button size="mini" round type="info">{{item.wtate}}</el-button>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
        :page-sizes="[10]" layout="total, sizes, prev, pager, next, jumper" :total="pageTotal.total" style="margin: 3.125rem;text-align:right">
      </el-pagination>
    </div>
    <div id="mfContents">
      <div id="mconList">
        <div id="mforumOne" v-for="(item, index) in mtableData" :key="index">
          <div id="fCon">
            <router-link tag="div" :to="{path:'/Social/forumDetials', query:{id:item.id,t:encodeURIComponent(item.title)}}"
              id="imgs">
              <img style="width: 100%;height: 100%;" :src="item.picture" />
            </router-link>
            <div id="conList">
              <router-link tag="div" style="color: #m956f17;" :to="{path:'/Social/forumDetials', query:{id:item.id,t:encodeURIComponent(item.title)}}">{{ item.title }}</router-link>
              <div>
                <div>活动时间：</div>
                <div style="margin-left: 30px;"><span>{{ item.hstime }}</span>&nbsp;-&nbsp;<span>{{ item.hetime }}</span></div>
              </div>
              <div>
                <div>报名时间：</div>
                <div style="margin-left: 30px;"><span>{{ item.bstime }}</span>&nbsp;-&nbsp;<span>{{ item.betime }}</span></div>
              </div>
              <div><span>主讲人：</span>{{ item.jname }}</div>
              <div><span>简介：</span>{{item.introductionstr}}</div>
              <div><span>活动地点：</span>{{ item.address }}</div>
              <div style="color: #mFF2222;"><span>已预约人数：</span><span>{{ item.numbers }}</span></div>
              <div style="margin-top: 10px;margin-bottom: 10px;">
                <span v-if="item.wtate === '预约报名'">
                  <router-link tag="el-button" :to="{path:'/Social/forumbm', query:{id:item.id,title:item.title}}" size="mini"
                    class="btn" type="success">{{item.wtate}}</router-link>
                </span>
                <span v-else-if="item.wtate === '报名未开始'">
                  <el-button size="mini" round>{{item.wtate}}</el-button>
                </span>
                <span v-else-if="item.wtate === '进行中'">
                  <el-button size="mini" round type="warning">{{item.wtate}}</el-button>
                </span>
                <span v-else>
                  <el-button size="mini" round type="info">{{item.wtate}}</el-button>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
        :page-sizes="[10]" layout="total, prev, pager, next" :total="pageTotal.total" style="margin: 1.875rem;text-align:right">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import qs from 'qs'
  import moment from 'moment'
  export default {
    data() {
      return {
        loading: false,
        tableData: [],
        pageTotal: [],
        currentPage: 1,
        pageSize: 10,
        pageNum: 1,
        str: '',
        mtableData: []
      }
    },
    mounted() {
      if (this.isMobile()) {
        document.getElementById("fContents").style.display = "none";
        document.getElementById("mfContents").style.display = "block";
        this.mhandleSearch();
      } else {
        document.getElementById("mfContents").style.display = "none";
        document.getElementById("fContents").style.display = "block";
        this.handleSearch();
      }
    },
    methods: {
      isMobile() {
        let flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        )
        return flag;
      },
      handleSizeChange(val) {
        this.pageSize = val;
      },
      handleCurrentChange(val) {
        this.pageNum = val;
        this.arrData = [];
        this.search();
      },
      mhandleSizeChange(val) {
        this.pageSize = val;
      },
      mhandleCurrentChange(val) {
        this.pageNum = val;
        this.marrData = [];
        this.msearch();
      },
      handleSearch() {
        this.search();
      },
      // 查询列表
      search: function() {
        let that = this;
        let url = this.HOST + '/api/v1/social/lectureAll?pageNumber=' + this.pageNum + '&pageSize=' + this.pageSize +
          '';
        this.loading = true;
        this.$axios.get(url).then(function(result) {
          let cData = result.data;
          that.pageTotal = cData.data;
          that.currentPage = that.pageTotal.pageNum;
          that.tableData = cData.data.list;
          for (let i = 0; i < that.tableData.length; i++) {
            let hstime = parseInt(that.tableData[i].htime);
            let hetime = parseInt(that.tableData[i].hendtime);
            //报名
            let bstime = parseInt(that.tableData[i].btime);
            let betime = parseInt(that.tableData[i].bendtime);
            that.tableData[i].hstime = moment(hstime).format("YYYY-MM-DD HH:mm");
            that.tableData[i].hetime = moment(hetime).format("YYYY-MM-DD HH:mm");
            that.tableData[i].bstime = moment(bstime).format("YYYY-MM-DD HH:mm");
            that.tableData[i].betime = moment(betime).format("YYYY-MM-DD HH:mm");
            if (that.tableData[i].introduction.length > 42) {
              that.tableData[i].introductionstr = (that.tableData[i].introduction).substring(0, 42) + "...";
            } else if (that.tableData[i].introduction.length < 42) {
              that.tableData[i].introductionstr = that.tableData[i].introduction;
            };
            let newtime = (new Date()).toLocaleDateString();
            newtime = newtime.replace(/\//g, '-');
            let nowdate = moment(newtime, 'YYYY-MM-DD HH:mm').valueOf();
            if (nowdate >= hstime && nowdate <= hetime) {
              that.tableData[i].wtate = "进行中";
            } else if (nowdate > hetime) {
              that.tableData[i].wtate = "已结束";
            } else if (nowdate < bstime) {
              that.tableData[i].wtate = "报名未开始";
            } else if (nowdate >= bstime && nowdate <= betime) {
              that.tableData[i].wtate = "预约报名";
            } else if (nowdate > betime) {
              that.tableData[i].wtate = "报名已结束";
            }
          }
          that.lensearch()
        }).catch(function(error) {
          console.log(err);
        })
      },
      lensearch: function() {
        let that = this;
        this.loading = true;
        for (let i = 0; i < this.tableData.length; i++) {
          let urls = this.HOST + '/api/v1/social/lectureBmCount/' + this.tableData[i].id + '';
          this.$axios.get(urls).then(function(results) {
            let pData = results.data;
            let url = that.HOST + '/api/v1/social/updateNumber/' + that.tableData[i].id + '/' + pData.data.count +
              '';
            that.$axios.put(url).then(function(result) {
              that.loading = false;
            }, function(err) {
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: err.toString(),
                duration: 2000
              });
            }).catch(function(erroe) {
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: '请求出现异常',
                duration: 2000
              });
            })
          }).catch(function(error) {
            console.log(error)
          });
        }
      },
      mhandleSearch() {
        this.msearch();
      },
      // 查询列表
      msearch: function() {
        let that = this;
        let url = this.HOST + '/api/v1/social/lectureAll?pageNumber=' + this.pageNum + '&pageSize=' + this.pageSize +
          '';
        this.loading = true;
        this.$axios.get(url).then(function(result) {
          let cData = result.data;
          that.pageTotal = cData.data;
          console.log(that.pageTotal)
          that.currentPage = that.pageTotal.pageNum;
          that.mtableData = cData.data.list;
          for (let i = 0; i < that.mtableData.length; i++) {
            let hstime = parseInt(that.mtableData[i].htime);
            let hetime = parseInt(that.mtableData[i].hendtime);
            //报名
            let bstime = parseInt(that.mtableData[i].btime);
            let betime = parseInt(that.mtableData[i].bendtime);
            that.mtableData[i].hstime = moment(hstime).format("YYYY-MM-DD HH:mm");
            that.mtableData[i].hetime = moment(hetime).format("YYYY-MM-DD HH:mm");
            that.mtableData[i].bstime = moment(bstime).format("YYYY-MM-DD HH:mm");
            that.mtableData[i].betime = moment(betime).format("YYYY-MM-DD HH:mm");
            if (that.mtableData[i].introduction.length > 42) {
              that.mtableData[i].introductionstr = (that.mtableData[i].introduction).substring(0, 42) + "...";
            } else if (that.mtableData[i].introduction.length < 42) {
              that.mtableData[i].introductionstr = that.mtableData[i].introduction;
            };
            let newtime = (new Date()).toLocaleDateString();
            newtime = newtime.replace(/\//g, '-');
            let nowdate = moment(newtime, 'YYYY-MM-DD HH:mm').valueOf();
            if (nowdate >= hstime && nowdate <= hetime) {
              that.mtableData[i].wtate = "进行中";
            } else if (nowdate > hetime) {
              that.mtableData[i].wtate = "已结束";
            } else if (nowdate < bstime) {
              that.mtableData[i].wtate = "报名未开始";
            } else if (nowdate >= bstime && nowdate <= betime) {
              that.mtableData[i].wtate = "预约报名";
            } else if (nowdate > betime) {
              that.mtableData[i].wtate = "报名已结束";
            }
          }
          that.mlensearch()
        }).catch(function(error) {
          console.log(err);
        })
      },
      mlensearch: function() {
        let that = this;
        that.loading = true;
        for (let i = 0; i < this.mtableData.length; i++) {
          let urls = this.HOST + '/api/v1/social/lectureBmCount/' + this.mtableData[i].id + '';
          this.$axios.get(urls).then(function(results) {
            let pData = results.data;
            if (pData && pData.data) {
              let url = that.HOST + '/api/v1/social/updateNumber/' + that.mtableData[i].id + '/' + pData.data.count +
                '';
              that.$axios.put(url).then(function(result) {
                that.loading = false;
              }, function(err) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }).catch(function(erroe) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: '请求出现异常',
                  duration: 2000
                });
              })
            }
          }).catch(function(error) {
            console.log(error)
          });
        }
      }
    }
  }
</script>

<style>
  #fContents {
    display: none;
    margin-top: 25px;
    margin-bottom: 25px;
  }

  .forumOne {
    width: 100%;
    height: 300px;
    border-bottom: 1px solid #dedede;
  }

  .btn {
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    background: #FFF;
    border: 1px solid #DCDFE6;
    -webkit-appearance: none;
    text-align: center;
    box-sizing: border-box;
    outline: 0;
    margin: 0;
    transition: .1s;
    font-weight: 500;
    font-size: 14px;
    border-radius: 20px;
    padding: 7px 15px;
    color: #fff;
    background-color: #67c23a;
    border-color: #67c23a;
  }

  .fCon {
    height: 300px;
    margin-bottom: 25px;
    margin-top: 25px;
  }

  .imgs {
    float: left;
    width: 400px;
    height: 250px;
    cursor: pointer;
  }

  .conList {
    float: left;
    width: 730px;
    height: 250px;
    margin-left: 50px;
  }

  .conList {
    text-align: left;
  }

  .conList>div:nth-child(1) {
    line-height: 35px;
    font-size: 1.2em;
    cursor: pointer;
  }

  .conList>div:nth-child(1):hover {
    color: #FF4500;
  }

  .conList>div:nth-child(2),
  .conList>div:nth-child(3),
  .conList>div:nth-child(4),
  .conList>div:nth-child(5),
  .conList>div:nth-child(6),
  .conList>div:nth-child(7) {
    line-height: 30px;
    font-size: 1em;
    color: #6a6969;
  }

  .conList>div:nth-child(8) {
    line-height: 50px;
  }

  /*mobile*/
  #mfContents {
    margin: auto 10px;
  }

  #mforumOne {
    border: 1px solid #956f17;
    border-radius: 5px;
    padding: 10px;
    margin-top: 10px;
  }

  #imgs {
    float: left;
    height: 250px;
    cursor: pointer;
  }

  #conList {
    text-align: left;
  }

  #conList>div:nth-child(1) {
    line-height: 35px;
    font-size: 1.2em;
    cursor: pointer;
  }

  #conList>div:nth-child(1):hover {
    color: #mFF4500;
  }

  #conList>div:nth-child(2),
  #conList>div:nth-child(3),
  #conList>div:nth-child(4),
  #conList>div:nth-child(5),
  #conList>div:nth-child(6),
  #conList>div:nth-child(7) {
    line-height: 30px;
    font-size: 1em;
    color: #6a6969;
  }

  #conList>div:nth-child(8) {
    line-height: 50px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Social/forum.vue